import { ReactNode } from "react";
// mui
import RtlMuiThemeProvider from "./RtlMuiThemeProvider";
// import { ThemeProvider } from "@emotion/react";
import { MuiTheme } from "../../theme/MuiTheme";
// toast alert
import { SnackbarProvider } from "notistack";
// redux
import { Provider } from "react-redux";
import { store } from "../../redux/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: false,
      gcTime: 0,
      refetchInterval: 0,
      staleTime: 0,
    },
  },
});
type Props = {
  children: ReactNode;
};

const Providers = ({ children }: Props) => {
  return (
    // {/* // rtl mui theme chaching and support  */}
    <Provider store={store}>
      <RtlMuiThemeProvider>
        {/* mui theme customization */}
        <ThemeProvider theme={MuiTheme}>
          {/* redux provider  */}
          <QueryClientProvider client={queryClient}>
            {children}
          </QueryClientProvider>
          {/* toast alert  */}
          <SnackbarProvider />
          <CssBaseline />
        </ThemeProvider>
      </RtlMuiThemeProvider>
    </Provider>
  );
};

export default Providers;
